"use strict";

/**
 * ESLint Base Configuration Settings
 * @type {object}
 */
var esLintBaseConfigurationSettings = {
    "parser": "babel-eslint",
    "parserOptions": {
        "ecmaVersion": 6,
        "sourceType": "module",
        "ecmaFeatures": {
            "experimentalObjectRestSpread": true,
            "modules": true,
            "jsx": true
        }
    },
    "plugins": ["react", "jsx-a11y", "import"],
    "settings": {
        "react": {
            "pragma": "React" // Pragma to use, default to "React"
        }
    },
    "env": {
        "browser": true,
        "node": true,
        "commonjs": true,
        "es6": true,
        "mocha": true
    },
    "extends": "airbnb",
    /*"extends": "eslint:recommended",*/
    "rules": {
        /* Rules Values Configuration
         *  - Rule Levels
         *  0 or "off"
         *  1 or "warn"
         *  2 or "error"
         *  - Rule declaration and assignment
         *  [Rule Level], additional options if applicable
         *  e.g. "quotes": [2, "double"]
         */
        "class-methods-use-this": "off",
        "complexity": [1, { "max": 5 }],
        "eol-last": "off",
        "indent": ["error", 4],
        "import/imports-first": "off",
        "jsx-a11y/no-static-element-interactions": "off",
        "max-len": "off",
        "new-cap": "off",
        "no-cond-assign": "error",
        "no-console": ["error", { "allow": ["warn", "error", "info"] }],
        "no-const-assign": "error",
        "no-constant-condition": "error",
        "no-debugger": "error",
        "no-duplicate-imports": "error",
        "no-else-return": "warn",
        "no-extra-semi": "warn",
        "no-plusplus": [2, { "allowForLoopAfterthoughts": true }],
        "no-script-url": "warn",
        "no-template-curly-in-string": "warn",
        "no-underscore-dangle": "off",
        "no-unreachable": "error",
        "no-restricted-syntax": [2, "WithStatement"],
        "no-unsafe-negation": "error",
        "prefer-const": "error",
        "radix": ["error", "as-needed"],
        "react/jsx-indent-props": "off",
        "react/jsx-filename-extension": "off",
        "react/jsx-indent": [2, 4],
        "react/jsx-no-bind": ["warn", {
            "ignoreRefs": true,
            "allowArrowFunctions": false,
            "allowBind": false
        }],
        "react/jsx-curly-spacing": "off",
        "react/forbid-prop-types": [2, { "forbid": ["any"] }],
        "react/no-array-index-key": "warn",
        "react/no-find-dom-node": "warn",
        "react/no-string-refs": "warn",
        "react/no-unused-prop-types": [2, { "skipShapeProps": true }],
        "react/prefer-es6-class": ["warn"],
        "react/sort-comp": "off",
        "spaced-comment": "off"
    }
};

module.exports = esLintBaseConfigurationSettings;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/linter/esLintBaseConfiguration.web.js
// module id = 866
// module chunks = 0